'use client';

import { signInWithCustomToken } from 'firebase/auth';
import { useEffect } from 'react';

import { auth } from '@/auth/firebase';
import { getEnvironmentLevel } from '@/lib/common-utils';

/**
 * E2E/automation only (non-production). Exposes window.__signInWithTestToken
 * so automation tests can log in via POST /me/test-auth without Google UI.
 * No logic in auth context; cleanup on unmount.
 */
function setupE2ETestAuth() {
  if (typeof window === 'undefined' || getEnvironmentLevel() === 'production') return;
  (window as unknown as { __signInWithTestToken?: (token: string) => Promise<void> }).__signInWithTestToken = (
    token: string,
  ) => signInWithCustomToken(auth, token).then(() => {});
}

function cleanupE2ETestAuth() {
  if (typeof window === 'undefined') return;
  delete (window as unknown as { __signInWithTestToken?: unknown }).__signInWithTestToken;
}

export function E2ETestAuthInit() {
  useEffect(() => {
    setupE2ETestAuth();
    return cleanupE2ETestAuth;
  }, []);
  return null;
}
